var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m12 11.56 4.876-4.876c.223-.223.573-.235.78-.027.21.208.197.558-.026.781l-4.876 4.876 4.876 4.875c.223.224.235.573.027.782-.208.208-.558.196-.781-.027L12 13.068l-4.876 4.876c-.223.223-.573.235-.78.027-.21-.209-.197-.558.026-.782l4.876-4.875L6.37 7.438c-.223-.223-.235-.573-.027-.781s.558-.196.781.027z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export default ForwardRef;